@tailwind base;
@tailwind components;
@tailwind utilities;


:host {
  display: block;
}

@keyframes slideInBottom {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideHorizontalIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideHorizontalOut {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(-100%);
    opacity: 0;
  }
}

/* You can define these as Tailwind classes using @apply if desired */
.animate-slide-in-bottom {
  animation: slideInBottom 0.5s ease-out forwards;
}

.animate-slide-horizontal-in {
  animation: slideHorizontalIn 0.5s ease-out forwards;
}

.animate-slide-horizontal-out {
  animation: slideHorizontalOut 0.5s ease-out forwards;
}

